import { Constant } from "src/constant";

export function buildAuthenticatorUrl({ secret, account }: { secret: string; account: string }): string {
    const { name, issuer } = Constant.mfaAuthenticatorApplication;
    return `otpauth://totp/${name}:${account}?secret=${secret}&issuer=${issuer}&digits=6`;
}